/** Auto-fix for ingested notes that do not fit the student format. Wired into `api.admin.ingestReview` via ingestReviewApi.ts. */

type RequestFn = <T>(path: string, options?: RequestInit, token?: string | null) => Promise<T>;

export type AutoFixBody = { course_id?: string; chapter_id?: string; dry_run?: boolean; confirm_apply?: boolean };

export type AutoFixReport = {
  dry_run: boolean;
  courses: { course_id: string; course: string; fixed: number; still_failing: number; already_ok: number; chapters: { chapter_id: string; version: number; result: "fixed" | "still_failing"; changes: number; errors: string[] }[] }[];
  result: { fixed: number; still_failing: number; already_ok: number; written: number };
};

export const ingestAutoFixApi = (request: RequestFn) => ({
  /** Dry run unless `dry_run: false` and `confirm_apply: true` are both sent. */
  autoFix: (token: string, body: AutoFixBody) => request<AutoFixReport>("/admin/ingest/auto-fix", { method: "POST", body: JSON.stringify(body) }, token),
});
